(() => {
  const initialized = new WeakSet();
  function setup(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    let cfg;
    try {
      cfg = JSON.parse(
        root.querySelector("[data-zn-order-config]").textContent,
      );
    } catch {
      return;
    }
    const c = {...{"mode":"connected","endpoint":"https://orders.zunatextil.com","payment_method":"cod","native_enabled":false,"native":"Continuar al pago en Shopify","demo":"Formulario de muestra: no se envían datos, no se cobra y no se crea un pedido.","example":"Rellenar con datos de ejemplo","pending":"Por confirmar","demo_price":"Sin precio de muestra","minimum":"Agrega {count} unidades para completar el mínimo de {minimum}.","loading":"Consultando tu pedido…","empty":"Tu pedido está vacío. Elige tus referencias en el catálogo.","city_error":"Selecciona un municipio que pertenezca al departamento elegido.","phone_error":"Escribe un celular colombiano de 10 dígitos que empiece por 3.","error":"No pudimos confirmar la solicitud. Tu carrito sigue disponible. Intenta de nuevo.","not_connected":"El formulario aún no tiene su conexión independiente configurada.","quote_expired":"El pedido o destino cambió. Consulta de nuevo el envío y el total.","demo_success":"Vista de confirmación: el formulario funciona en demostración. No se enviaron datos ni se creó un pedido.","checking":"Tu solicitud está en verificación. Comprueba su estado antes de volver a enviar."},...cfg.settings},
      $ = (s) => root.querySelector(s),
      form = $("[data-zn-order-form]"),
      field = (n) => form.elements.namedItem(n),
      demo = cfg.demo || c.mode !== "connected",
      t = (key, vars = {}) =>
        Object.entries(vars).reduce(
          (text, [k, v]) => text.replaceAll("{" + k + "}", String(v)),
          c[key] || key,
        ),
      norm = (s) =>
        String(s)
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .trim(),
      minimum = 6,
      money = (n) =>
        new Intl.NumberFormat("es-CO", {
          style: "currency",
          currency: "COP",
          maximumFractionDigits: 0,
        }).format(n / 100);
    let items = [],
      geo = null,
      quote = null,
      busy = !1,
      pending = null,
      completed = !1;
    const pendingKey = cfg.brand + ":pending-order:v2";
    try {
      ((pending = JSON.parse(sessionStorage.getItem(pendingKey) || "null")),
        (!pending?.id || !pending?.hash) && (pending = null));
    } catch {}
    const say = (message) => {
        $("[data-zn-order-status]").textContent = message;
      },
      count = () => items.filter(x => norm(x.product_type) === "camiseta").reduce((s, x) => s + x.quantity, 0),
      cartKey = () =>
        JSON.stringify(
          items.map((x) => [String(x.variant_id || x.id), x.quantity]).sort(),
        );
    function paint() {
      const list = $("[data-zn-order-lines]");
      list.replaceChildren();
      for (const item of items) {
        const li = document.createElement("li"),
          name = document.createElement("strong"),
          detail = document.createElement("span");
        ((name.textContent = item.title),
          (detail.textContent =
            "\xD7 " +
            item.quantity +
            (Number.isInteger(item.final_line_price)
              ? " \xB7 " + money(item.final_line_price)
              : "")),
          li.append(name, detail),
          list.append(li));
        const label=document.createElement('label');label.textContent='Cantidad ';
        const qty=document.createElement('input');qty.type='number';qty.min='0';qty.max='1000';qty.step='1';qty.value=item.quantity;qty.disabled=busy||!!pending||completed;qty.dataset.znCartQuantity='';qty.setAttribute('aria-label','Cantidad de '+item.title);
        let quantityTimer=null,committing=false;
        const commit=async()=>{
          clearTimeout(quantityTimer);if(committing)return;
          const n=Number(qty.value);if(!qty.value||!Number.isSafeInteger(n)||n<0||n>1000){say('Escribe una cantidad entera entre 0 y 1000.');return;}
          if(n===item.quantity){invalidate();return;}
          committing=true;busy=true;quote=null;paint();say('Actualizando cantidad y envío…');
          try{await shopCart('change',{id:item.id,quantity:n});items=await cart();invalidate();}
          catch(e){say(e.message);}
          finally{busy=false;committing=false;paint();}
        };
        qty.addEventListener('input',()=>{
          clearTimeout(quantityTimer);clearTimeout(quoteTimer);quoteRevision++;quote=null;
          $('[data-zn-order-submit]').disabled=true;
          for(const k of ['shipping','total']) $('[data-zn-order-'+k+']').textContent='Actualizando…';
          quantityTimer=setTimeout(commit,400);
        });
        qty.addEventListener('change',commit);label.append(qty);li.append(label);
      }
      const minimumNotice = $("[data-zn-order-minimum]");
      ((minimumNotice.hidden = count() >= minimum),
        (minimumNotice.textContent = count()
          ? t("minimum", { count: Math.max(0, minimum - count()), minimum })
          : t("empty")));
      for (const k of ["subtotal", "discount", "shipping", "total"])
        $("[data-zn-order-" + k + "]").textContent = quote
          ? money(quote.totals[k])
          : k === "subtotal" &&
              items.length &&
              items.every((x) => Number.isInteger(x.final_line_price))
            ? money(items.reduce((n, x) => n + x.final_line_price, 0))
            : t(cfg.demo ? "demo_price" : "pending");
      (($("[data-zn-order-submit]").disabled =
        busy || count() < minimum || !!pending || completed || (!demo && (!quote || quote.preview))),
        ($("[data-zn-quote]").disabled =
          busy || count() < minimum || !!pending || completed));
      const native = $("[data-zn-native]");
      (native &&
        (native.disabled = busy || count() < minimum || !!pending || completed),
        ($("[data-zn-order-status-check]").hidden = !pending),
        ($("[data-zn-order-status-check]").disabled = busy),
        ($("[data-zn-example]").hidden = !demo));
    }

    const sessionKey='zuna:session:v1';
    let sessionToken=null,sessionPromise=null,saveTimer=null;
    try {sessionToken=sessionStorage.getItem(sessionKey);}catch{}
    async function ensureSession(){
      if(sessionToken)return;
      sessionPromise ||= request('/v1/session/init',{}).then(r=>{sessionToken=r.sessionToken;try{sessionStorage.setItem(sessionKey,sessionToken);}catch{}rememberForm();}).finally(()=>{sessionPromise=null;});
      await sessionPromise;
    }
    function readCustomer(){
      const result=Object.fromEntries(['first_name','last_name','email','address1','address2'].map(k=>[k,field(k).value.trim()]));
      let phone=field('phone').value.replace(/[\s()+.-]/g,'');if(phone.length===12&&phone.startsWith('57'))phone=phone.slice(2);
      if(!/^3\d{9}$/.test(phone))throw Error(t('phone_error'));
      result.phone='+57'+phone;return result;
    }
    function readPartialCustomer(){
      const result=Object.fromEntries(['first_name','last_name','email','address1','address2'].map(k=>[k,field(k).value.trim()]));
      let phone=field('phone').value.replace(/[\s()+.-]/g,'');if(phone.length===12&&phone.startsWith('57'))phone=phone.slice(2);
      result.phone=/^3\d{9}$/.test(phone)?'+57'+phone:'';
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(result.email))result.email='';
      return result;
    }
    function readMarketing(){return {email:field('marketing_email')?.checked===true,whatsapp:field('marketing_whatsapp')?.checked===true};}
    const memoryKey='zuna:form-memory:v1';let memoryRestored=false;
    function rememberForm(){if(demo||completed)return;try{const values=Object.fromEntries(['first_name','last_name','phone','email','address1','address2','province','city','deliveryType','coupon'].map(k=>[k,field(k).value]));localStorage.setItem(memoryKey,JSON.stringify({at:Date.now(),values,sessionToken}));}catch{}}
    function restoreForm(){if(memoryRestored)return;memoryRestored=true;try{const saved=JSON.parse(localStorage.getItem(memoryKey)||'null');if(!saved||Date.now()-saved.at>86400000){localStorage.removeItem(memoryKey);return;}if(!sessionToken&&saved.sessionToken){sessionToken=saved.sessionToken;sessionStorage.setItem(sessionKey,sessionToken);}for(const [k,v] of Object.entries(saved.values||{})){const input=field(k);if(input&&typeof v==='string'&&v.length<=254&&!input.value){input.value=v;if(k==='province')provinceChanged();}}}catch{}}
    function partialDestination(){let d={province:field('province').value,city:''};try{d=destination();}catch{}return d;}
    function analyticsAllowed(){return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;}
    function publish(name,data){if(analyticsAllowed())window.Shopify?.analytics?.publish?.(name,data);}
    function attribution(){
      const output={source_url:location.origin+location.pathname};if(!analyticsAllowed())return output;
      const params=new URLSearchParams(location.search);for(const k of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid']){const v=params.get(k);if(v)output[k]=v.slice(0,250);}
      try{const saved=JSON.parse(sessionStorage.getItem('zuna:attribution:v1')||'{}');Object.assign(output,{...saved,...output});sessionStorage.setItem('zuna:attribution:v1',JSON.stringify(output));}catch{}
      return output;
    }
    async function saveQualified(){
      if(demo||completed||pending||!items.length)return;
      rememberForm();const customer=readPartialCustomer();if(!customer.phone&&!customer.email&&!customer.first_name)return;
      await request('/v1/session',{items:payloadItems(),customer,destination:partialDestination(),deliveryType:field('deliveryType').value,marketing:readMarketing(),captureNotice:'zuna-recovery-v1',consent:field('confirm_whatsapp').checked&&field('confirm_order').checked,coupon:field('coupon').value.trim(),attribution:attribution()});
    }
    async function shopCart(action,body){
      const response=await fetch(cfg.root.replace(/\/$/,'')+'/cart/'+action+'.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
      const data=await response.json();if(!response.ok)throw Error(data.description||'No pudimos actualizar tu carrito.');
      document.dispatchEvent(new CustomEvent('zuna:cart:changed',{detail:data}));return data;
    }
    async function removePurchased(purchased){
      const current=await cart(),remaining=new Map(purchased.map(x=>[x.variant_id,x.quantity])),updates={};
      for(const line of current){const n=Math.min(line.quantity,remaining.get(line.variant_id)||0);if(n){updates[line.id]=line.quantity-n;remaining.set(line.variant_id,remaining.get(line.variant_id)-n);}}
      if(Object.keys(updates).length)await shopCart('update',{updates});
    }
    document.addEventListener('click',async event=>{
      const button=event.target.closest('[data-zuna-product-order]');if(!button||!root.isConnected||button.disabled)return;
      event.preventDefault();button.disabled=true;
      try{await open();}finally{button.disabled=false;}
    });
    for(const button of document.querySelectorAll('[data-zuna-product-order]'))button.textContent=c.cod_button||'Pagar contra entrega';
    const recovery=new URLSearchParams(location.search).get('zuna_recover');
    if(recovery&&!demo){
      const url=new URL(location.href);url.searchParams.delete('zuna_recover');history.replaceState(null,'',url);
      (async()=>{const r=await request('/v1/recover',{recoveryToken:recovery});if(!r.ok||!r.items?.length){say('Este enlace ya no tiene un carrito disponible.');return;}sessionToken=r.sessionToken;try{sessionStorage.setItem(sessionKey,sessionToken);}catch{}const current=await cart();const totals=new Map();for(const i of current)totals.set(i.variant_id,(totals.get(i.variant_id)||0)+i.quantity);const add=r.items.map(i=>({id:i.variant_id,quantity:Math.max(0,i.quantity-(totals.get(i.variant_id)||0))})).filter(i=>i.quantity);if(add.length)await shopCart('add',{items:add});field('coupon').value=r.coupon||'';items=await cart();await open();invalidate();say('Recuperamos tus productos. Completa tus datos y consulta el total actualizado.');})().catch(e=>say(e.message));
    }

    async function request(path, body) {
      if(path !== "/v1/session/init" && path !== "/v1/recover") {await ensureSession(); body={...body,sessionToken};}
      let url;
      try {
        if (
          ((url = new URL(c.endpoint)),
          url.origin !== "https://orders.zunatextil.com" || url.username || url.password)
        )
          throw Error();
      } catch {
        throw Error("not_connected");
      }
      ((url.pathname = url.pathname.replace(/\/$/, "") + path),
        (url.search = ""),
        (url.hash = ""));
      const controller = new AbortController(),
        timer = setTimeout(() => controller.abort(), 55000);
      try {
        const r = await fetch(url.href, {
          method: "POST",
          mode: "cors",
          credentials: "omit",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          keepalive: path === "/v1/session",
          body: JSON.stringify({ ...body, brand: cfg.brand }),
          signal: controller.signal,
        });
        let result;
        try {
          result = await r.json();
        } catch {
          throw Error("error");
        }
        if (!r.ok) {const error=new Error(result.message || t('error'));error.code=result.code;throw error;}
        return result;
      } finally {
        clearTimeout(timer);
      }
    }
    async function cart() {
      if (cfg.demo) return window.ZunaBasket?.get() || [];
      const response = await fetch(cfg.cart.replace(/\/$/, "") + ".js", {
        credentials: "same-origin",
        cache: "no-store",
        headers: { Accept: "application/json" },
      });
      if (!response.ok) throw Error("error");
      const data = await response.json();
      if (!Array.isArray(data.items)) throw Error("error");
      return data.items.map((x) => ({
        id: String(x.key),
        variant_id: String(x.variant_id),
        quantity: x.quantity,
        product_type: x.product_type,
        title:
          x.product_title + (x.variant_title ? " \xB7 " + x.variant_title : ""),
        final_line_price: x.final_line_price,
      }));
    }
    async function locations() {
      if (geo) return;
      const r = await fetch(cfg.locations, { credentials: "omit" });
      if (!r.ok) throw Error("error");
      geo = await r.json();
      for (const d of geo.departments) {
        const option = document.createElement("option");
        ((option.value = d.id),
          (option.textContent = d.name),
          field("province").append(option));
      }
    }
    function provinceChanged() {
      const d = geo?.departments.find((x) => x.id === field("province").value);
      ((field("city").value = ""), (field("city").disabled = !d));
      const list = $("#ZunaCities");
      list.replaceChildren();
      for (const city of d?.cities || []) {
        const option = document.createElement("option");
        ((option.value = city.name), list.append(option));
      }
    }
    function destination() {
      const d = geo?.departments.find((x) => x.id === field("province").value),
        city = d?.cities.find(
          (x) => norm(x.name) === norm(field("city").value),
        );
      if (!city) throw Error("city_error");
      return {
        province: d.id,
        province_name: d.name,
        city: city.id,
        city_name: city.name,
      };
    }
    const payloadItems = () =>
      items.map((x) => ({
        variant_id: String(x.variant_id || x.id),
        quantity: x.quantity,
      }));
    let quoteTimer=null, quoteRevision=0;
    function invalidate() {
      quoteRevision++; clearTimeout(quoteTimer); quoteTimer=setTimeout(autoQuote,250);
      ((quote = null), paint());
    }
    let minimumPopup = null, opening = false;
    function showMinimumPopup(errorMessage) {
      if (!minimumPopup) {
        minimumPopup = document.createElement('dialog');
        minimumPopup.className = 'zn-minimum-popup';
        minimumPopup.setAttribute('aria-labelledby', 'ZunaMinimumTitle');
        minimumPopup.setAttribute('aria-describedby', 'ZunaMinimumDetails');
        minimumPopup.innerHTML = '<button type="button" class="zn-minimum-close" aria-label="Cerrar aviso">×</button><span class="zn-minimum-badge">COMPRA AL POR MAYOR</span><h2 id="ZunaMinimumTitle">Tu pedido empieza con 6 camisetas</h2><p id="ZunaMinimumDetails" class="zn-minimum-count"></p><p>Puedes combinar diseños, colores y tallas hasta completar las 6 camisetas.</p><div class="zn-minimum-shipping"><strong>¿Cuánto cuesta el envío?</strong><p>Se calcula según tu destino y la cantidad de camisetas. Al completar el mínimo, elige tu destino y calcularemos el envío automáticamente. Verás el total con envío antes de confirmar.</p></div><button type="button" class="zn-minimum-continue">Seguir eligiendo camisetas</button><a class="zn-minimum-cart">Ver mi carrito</a>';
        minimumPopup.querySelector('.zn-minimum-cart').href = cfg.cart;
        for (const button of minimumPopup.querySelectorAll('button')) button.addEventListener('click', () => minimumPopup.close());
        root.insertAdjacentElement('afterend', minimumPopup);
      }
      const n = count(), missing = Math.max(0, minimum - n);
      minimumPopup.querySelector('.zn-minimum-count').textContent = errorMessage || ('Llevas ' + n + ' de 6. ' + (missing === 1 ? '¡Te falta 1 camiseta!' : '¡Te faltan ' + missing + ' camisetas!'));
      if (root.open) root.close();
      if (!minimumPopup.open) minimumPopup.showModal();
    }
    async function open() {
      if (opening) return;
      opening = true;
      try { items = await cart(); }
      catch (_) { opening = false; showMinimumPopup('No pudimos revisar tu carrito. Cierra este aviso e intenta de nuevo.'); return; }
      opening = false;
      if (count() < minimum && !pending) { showMinimumPopup(); return; }
      if (minimumPopup?.open) minimumPopup.close();

      for (const other of document.querySelectorAll("dialog[open]"))
        other !== root && other.close();
      (root.open || root.showModal(),
        (completed = !1),
        ($("[data-zn-order-body]").hidden = !1),
        ($("[data-zn-order-success]").hidden = !0),
        (busy = !0),
        say(t(demo ? "demo" : "loading")),
        paint());
      try {
        ((items = await cart()),
          await locations(),
          restoreForm(),
          invalidate(),
          say(t(pending ? "checking" : demo ? "demo" : "shipping_note")));
        publish("zuna_checkout_started",{quantity:count(),currency:"COP"});
      } catch (e) {
        say(t(e.message));
      } finally {
        ((busy = !1), paint());
      }
    }
    async function refresh() {
      const before = cartKey();
      if (
        ((items = await cart()),
        before !== cartKey() && (quote = null),
        paint(),
        count() < minimum)
      )
        throw Error("empty");
    }
    function validTotals(q) {
      const n = q?.totals;
      return (
        q?.quoteToken &&
        Number.isFinite(q.expires_at) &&
        q.expires_at > Date.now() &&
        n?.currency === "COP" &&
        n?.unit === "centavos" &&
        ["subtotal", "discount", "shipping", "total"].every(
          (k) => Number.isSafeInteger(n[k]) && n[k] >= 0,
        ) &&
        Number.isSafeInteger(n.tax) && n.tax >= 0
      );
    }
    function readyDestination() {try {destination();return count()>=minimum;}catch{return false;}}
    function autoQuote() {
      if(!root.open || pending || completed || !readyDestination()) return;
      if(busy){quoteTimer=setTimeout(autoQuote,300);return;}
      quoteOrder();
    }
    async function quoteOrder() {
      if(busy || pending || completed || !readyDestination())return;
      const revision=quoteRevision;
      busy=true;paint();for(const k of ['shipping','total']) $('[data-zn-order-'+k+']').textContent='Calculando…';$('[data-zn-quote]').hidden=true;
      try {
        const dest=destination(), final=form.checkValidity();
        if(demo){say(t('demo'));return;}
        say('Calculando envío y total…');
        const body={items:payloadItems(),destination:dest,coupon:field('coupon').value.trim(),deliveryType:field('deliveryType').value,preview:!final};
        if(final){body.customer=readCustomer();body.consent=field('confirm_whatsapp').checked&&field('confirm_order').checked;}
        const q=await request('/v1/quote',body);
        if(revision!==quoteRevision)return;
        if(q.preview ? !q.totals || !['subtotal','discount','shipping','total'].every(k=>Number.isSafeInteger(q.totals[k])&&q.totals[k]>=0) : !validTotals(q))throw Error('error');
        quote={...q,cart:cartKey(),destination:JSON.stringify(dest),coupon:field('coupon').value.trim(),deliveryType:field('deliveryType').value};
        say(q.preview?'Envío incluido en el total. Completa tus datos y las confirmaciones para enviar el pedido.':'Total actualizado con envío. Ya puedes confirmar tu pedido.');
      }catch(e){if(revision===quoteRevision){quote=null;say(t(e.message));$('[data-zn-quote]').hidden=false;}}
      finally{busy=false;paint();if(revision!==quoteRevision){clearTimeout(quoteTimer);quoteTimer=setTimeout(autoQuote,550);}}
    }
    async function hash(text) {
      return [
        ...new Uint8Array(
          await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text)),
        ),
      ]
        .map((x) => x.toString(16).padStart(2, "0"))
        .join("");
    }
    async function confirmed(result) {
      if (
        result?.ok !== !0 ||
        typeof result.order_id != "string" ||
        !result.order_id
      )
        throw Error("error");
      const purchased = payloadItems();
      publish("zuna_order_submitted",{order_id:result.order_id,event_id:result.event_id,value:result.totals?.total/100,currency:"COP",payment_method:"cod"});
      try {await removePurchased(purchased);} catch {say("Pedido recibido. Actualiza tu carrito antes de hacer otro pedido.");}
      sessionToken=null;try{sessionStorage.removeItem(sessionKey);localStorage.removeItem(memoryKey);}catch{}
      pending = null;
      try {
        sessionStorage.removeItem(pendingKey);
      } catch {}
      ((completed = !0),
        ($("[data-zn-order-body]").hidden = !0),
        ($("[data-zn-order-success]").hidden = !1),
        ($("[data-zn-order-success-title]").textContent = t("success", {
          order: result.order_id,
        })),
        form.reset(),
        provinceChanged(),
        (quote = null));
    }
    async function submit(e) {
      if ((e.preventDefault(), !(busy || pending || !form.reportValidity()))) {
        ((busy = !0), paint());
        try {
          await refresh();
          const dest = destination();
          let phone = field("phone").value.replace(/\D/g, "");
          if (
            (phone.length === 12 &&
              phone.startsWith("57") &&
              (phone = phone.slice(2)),
            !/^3\d{9}$/.test(phone))
          )
            throw Error("phone_error");
          if (demo) {
            (($("[data-zn-order-success-title]").textContent =
              t("demo_success")),
              ($("[data-zn-order-body]").hidden = !0),
              ($("[data-zn-order-success]").hidden = !1));
            return;
          }
          if (
            !quote ||
            quote.expires_at <= Date.now() ||
            quote.cart !== cartKey() ||
            quote.destination !== JSON.stringify(dest) ||
            quote.coupon !== field("coupon").value.trim()
          )
            throw ((quote = null), Error("quote_expired"));
          const customer = Object.fromEntries(
            ["first_name", "last_name", "email", "address1", "address2"].map(
              (k) => [k, field(k).value.trim()],
            ),
          );
          customer.phone = "+57" + phone;
          const body = {
            quoteToken: quote.quoteToken,
            items: payloadItems(),
            destination: dest,
            customer,
            consent: !0, marketing:readMarketing(), confirmWhatsapp:field("confirm_whatsapp").checked, confirmOrder:field("confirm_order").checked,
            payment_method: "cod",
            coupon: field("coupon").value.trim(), deliveryType: field("deliveryType").value, attribution: attribution(),
          };
          try {
            const ref = sessionStorage.getItem(cfg.brand + ":referral:v2");
            /^[a-f0-9]{32}$/.test(ref || "") && (body.referral = ref);
          } catch {}
          pending = {
            id: crypto.randomUUID(),
            hash: await hash(JSON.stringify(body)),
          };
          try {
            sessionStorage.setItem(pendingKey, JSON.stringify(pending));
          } catch {}
          say(t("loading"));
          const result = await request("/v1/orders", {
            ...body,
            operationId: pending.id,
          });
          if (result.status === "pending") {
            say(t("checking"));
            return;
          }
          await confirmed(result);
        } catch (e2) {
          say(t(pending ? "checking" : e2.message));
        } finally {
          ((busy = !1), paint());
        }
      }
    }
    async function checkStatus() {
      if (!(busy || !pending || demo)) {
        ((busy = !0), paint(), say(t("checking")));
        try {
          let result = await request("/v1/orders/status", {
            operationId: pending.id,
          });
          if (
            (result.status === "not_found" &&
              (result = await request("/v1/orders/cancel", {
                operationId: pending.id,
              })),
            result.ok === !0 && result.status === "converted")
          )
            await confirmed(result);
          else if (result.status === "rejected") {
            pending = null;
            try {
              sessionStorage.removeItem(pendingKey);
            } catch {}
            ((quote = null), say(t("quote_expired")));
          } else say(t("checking"));
        } catch {
          say(t("checking"));
        } finally {
          ((busy = !1), paint());
        }
      }
    }
    (document.addEventListener("zuna:order:open", () => {
      root.isConnected && open();
    }),
      document.addEventListener("click", (e) => {
        root.isConnected && e.target.closest("[data-zn-open-order]") && open();
      }),
      field("province").addEventListener("change", () => {
        (provinceChanged(), invalidate());
      }));
    $('[data-zn-forget]')?.addEventListener('click',()=>{if(busy||pending)return;clearTimeout(saveTimer);for(const k of ['first_name','last_name','phone','email','address1','address2','province','city','deliveryType','coupon'])field(k).value='';field('confirm_whatsapp').checked=false;field('confirm_order').checked=false;provinceChanged();sessionToken=null;try{localStorage.removeItem(memoryKey);sessionStorage.removeItem(sessionKey);}catch{}invalidate();say('Borramos los datos recordados en este navegador.');});
    form.addEventListener("change",(e)=>{if(e.target.matches("[data-zn-cart-quantity]"))return;invalidate();});
    form.addEventListener("input",(e)=>{if(e.target.matches("[data-zn-cart-quantity]"))return;rememberForm();invalidate();clearTimeout(saveTimer);saveTimer=setTimeout(()=>saveQualified().catch(()=>{}),700);});
    document.addEventListener("visibilitychange",()=>{if(document.visibilityState==="hidden"){clearTimeout(saveTimer);saveQualified().catch(()=>{});}});
    root.addEventListener("close",()=>{clearTimeout(saveTimer);saveQualified().catch(()=>{});});
    (form.addEventListener("submit", submit),
      $("[data-zn-quote]").addEventListener("click", quoteOrder),
      $("[data-zn-order-status-check]").addEventListener("click", checkStatus),
      $("[data-zn-example]").addEventListener("click", () => {
        if (!demo || !geo) return;
        for (const [k, v] of Object.entries({
          first_name: "Cliente",
          last_name: "de prueba",
          phone: "3000000000",
          email: "",
          address1: "Calle de ejemplo 123",
          address2: "",
        }))
          field(k).value = v;
        const d =
          geo.departments.find((x) => norm(x.name).includes("bogota")) ||
          geo.departments[0];
        ((field("province").value = d.id),
          provinceChanged(),
          (field("city").value = d.cities[0].name),
          (field("confirm_whatsapp").checked = !0), (field("confirm_order").checked = !0),
          invalidate(),
          say(t("demo")));
      }),
      $("[data-zn-native]")?.addEventListener("click", async () => {
        if (!(busy || pending)) {
          if (cfg.demo) {
            say(t("demo"));
            return;
          }
          ((busy = !0), paint());
          try {
            (await refresh(),
              location.assign(cfg.root.replace(/\/$/, "") + "/checkout"));
          } catch (e) {
            say(t(e.message));
          } finally {
            ((busy = !1), paint());
          }
        }
      }),
      $("[data-zn-order-return]").addEventListener("click", () => root.close()),
      paint());
  }
  (document.querySelectorAll("[data-zn-order]").forEach(setup),
    document.addEventListener("shopify:section:load", () =>
      document.querySelectorAll("[data-zn-order]").forEach(setup),
    ));
})();



